import shopDetailOtherDish from './oherDish'
import shopDetailOtherEmail from './oherEmail'
import shopDetailOtherBankflow from './oherBankflow'
import shopDetailOtherExtra from './oherExtra'
import baseDetail from './baseDetail'

export default {
  shopDetailOtherDish,
  shopDetailOtherEmail,
  shopDetailOtherBankflow,
  shopDetailOtherExtra,
  baseDetail                // 基础信息
}
